import { createAction, props } from '@ngrx/store';
import { ProfilePictureMapping } from '@wap/profile-picture';

export const selectParent = createAction('[Landing Page] Select Parent');

export const loadProfilePictures = createAction(
  '[Upstart Landing Page] Load Profile Pictures',
  props<{ studentIds: string[] }>(),
);

export const loadProfilePicturesSuccess = createAction(
  '[Profile Picture API] Load Profile Pictures Success',
  props<{ profilePictures: ProfilePictureMapping[] }>(),
);
